import React from 'react';
import { Link } from 'react-router-dom';
import './RecipeCard.css';

function RecipeCard({ recipe }) {
  const image = recipe.images && recipe.images.length > 0 ? recipe.images[0].url : null;
  const difficultyColor = { easy: '#4caf50', medium: '#ff9800', hard: '#f44336' };
  const difficultyLabel = { easy: 'Fácil', medium: 'Media', hard: 'Difícil' };

  return (
    <Link to={`/recipes/${recipe.id}`} className="recipe-card">
      {image
        ? <img src={image} alt={recipe.title} className="recipe-card-img" />
        : <div className="recipe-card-img recipe-card-placeholder">🍽️</div>
      }
      <div className="recipe-card-body">
        <h3 className="recipe-card-title">{recipe.title}</h3>
        <p className="recipe-card-desc">
          {recipe.description?.slice(0, 80)}{recipe.description?.length > 80 ? '…' : ''}
        </p>
        <div className="recipe-card-meta">
          {recipe.prep_time && <span>⏱ {recipe.prep_time} min</span>}
          {recipe.difficulty && (
            <span
              className="recipe-badge"
              style={{ backgroundColor: difficultyColor[recipe.difficulty] || '#999' }}
            >
              {difficultyLabel[recipe.difficulty] || recipe.difficulty}
            </span>
          )}
        </div>
        {recipe.author && <p className="recipe-card-author">por {recipe.author}</p>}
      </div>
    </Link>
  );
}

export default RecipeCard;
